import {Facebook} from '@helios/shared/images/icons/facebook'
import {Instagram} from '@helios/shared/images/icons/instagram'
import {Linkedin} from '@helios/shared/images/icons/linkedin'
import {Twitter} from '@helios/shared/images/icons/twitter'
import {Youtube} from '@helios/shared/images/icons/youtube'

export const socialHandles = {
    facebook: 'pleo.io',
    twitter: 'pleo',
    linkedin: 'pleo-company',
    instagram: 'pleo.io',
    youtube: 'UCQQitvQIlEgIxNyLlOgilXQ',
}

export const socialLinks = [
    {
        handle: socialHandles.linkedin,
        url: `https://www.linkedin.com/company/${socialHandles.linkedin}`,
        icon: Linkedin,
        name: 'LinkedIn',
    },
    {
        handle: socialHandles.twitter,
        url: `https://www.twitter.com/${socialHandles.twitter}`,
        icon: Twitter,
        name: 'Twitter',
    },
    {
        handle: socialHandles.facebook,
        url: `https://www.facebook.com/${socialHandles.facebook}`,
        icon: Facebook,
        name: 'Facebook',
    },
    {
        handle: socialHandles.instagram,
        url: `https://www.instagram.com/${socialHandles.instagram}`,
        icon: Instagram,
        name: 'Instagram',
    },
    {
        handle: socialHandles.youtube,
        url: `https://www.youtube.com/channel/${socialHandles.youtube}`,
        icon: Youtube,
        name: 'YouTube',
    },
]
